<template>
  <div class="mb-n8 mx-4 my-3">
    <v-card class="mx-auto" outlined elevation="4" :class="computedClasses">
      <v-container>
        <v-row class="px-10">
          <v-col cols="6">
            <v-row>
              <v-col cols="12">
                <v-card-title class="mt-n6">
                  <span class="indigo--text text-subtitle-1">
                    <v-tooltip top v-if="computedChip == 1">
                      <template v-slot:activator="{ on, attrs }">
                        <span v-on="on" v-bind="attrs">
                          <v-icon
                            color="yellow darken-3"
                            class="mr-1 ml-n8 mb-1"
                            slot="activator"
                          >
                            mdi-alert-circle-outline
                          </v-icon>
                        </span>
                      </template>
                      <span>Route Near Due</span>
                    </v-tooltip>

                    <v-tooltip top v-else-if="computedChip == 2">
                      <template v-slot:activator="{ on, attrs }">
                        <span v-on="on" v-bind="attrs">
                          <v-icon
                            color="green darken-1"
                            class="mr-1 ml-n8 mb-1"
                            slot="activator"
                          >
                            mdi-check-circle-outline
                          </v-icon>
                        </span>
                      </template>
                      <span>Route Completed</span>
                    </v-tooltip>

                    <v-tooltip top v-else-if="computedChip == 3">
                      <template v-slot:activator="{ on, attrs }">
                        <span v-on="on" v-bind="attrs">
                          <v-icon
                            color="orange"
                            class="mr-1 ml-n8 mb-1"
                            slot="activator"
                          >
                            mdi-alert-circle-outline
                          </v-icon>
                        </span>
                      </template>
                      <span>Route Overdue</span>
                    </v-tooltip>

                    <v-tooltip top v-else>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-on="on" v-bind="attrs">
                          <v-badge
                            dot
                            left
                            class="ml-n3 mr-2 pb-1"
                            color="indigo"
                          ></v-badge>
                        </span>
                      </template>
                      <span>Pending</span>
                    </v-tooltip>

                    {{ child.action.name }}
                  </span>
                  <v-spacer></v-spacer>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-on="on" v-bind="attrs">
                        <v-badge
                          class="mr-4 pb-1"
                          dot
                          color="grey"
                          v-show="computedDisableStatus"
                        ></v-badge>
                      </div>
                    </template>
                    <span>
                      Pending for confirmation
                    </span>
                  </v-tooltip>
                </v-card-title>
              </v-col>
              <v-col cols="12" class="mt-n14">
                <v-card-subtitle
                  class="text-h6 black--text"
                  v-if="!view_more_status"
                >
                  <div v-html="computedInstructions" class="d-inline"></div>
                  <v-btn
                    class="d-inline"
                    style="padding: 0px;"
                    color="indigo"
                    small
                    text
                    v-if="child.instructions.length >= 250"
                    @click="view_more_status = true"
                    >view more...</v-btn
                  >
                </v-card-subtitle>
                <v-card-subtitle class="text-h6 black--text" v-else>
                  <div v-html="child.instructions" class="d-inline"></div>
                  <v-btn
                    class="d-inline"
                    style="padding: 0px;"
                    color="indigo"
                    small
                    text
                    @click="view_more_status = false"
                    >view less...</v-btn
                  >
                </v-card-subtitle>
                <v-card-subtitle
                  class="mt-n4 indigo--text"
                  v-if="child.route_delegated_users.length < 1"
                >
                  <v-icon small color="indigo">mdi-account</v-icon>
                  {{ child.user.first_name }}
                  {{ child.user.middle_name }}
                  {{ child.user.last_name }}
                </v-card-subtitle>
                <v-card-subtitle class="mt-n4 indigo--text" v-else>
                  <v-icon small color="indigo">mdi-account</v-icon>
                  {{ child.route_delegated_users[0].user.first_name }}
                  {{ child.route_delegated_users[0].user.middle_name }}
                  {{ child.route_delegated_users[0].user.last_name }}
                  <span class="ml-4 red--text"
                    >(Delegated by {{ child.user.first_name }}
                    {{ child.user.middle_name }}
                    {{ child.user.last_name }})</span
                  >
                </v-card-subtitle>
                <v-card-subtitle class="mt-n6 indigo--text">
                  <v-icon small class="d-inline mr-2" color="grey darken-3">
                    mdi-calendar-clock
                  </v-icon>
                  <DateCountdown
                    :routeId="child.id"
                    :routeType="routeType"
                    :date="child.datetime_due"
                    :currentStatus="computedStatusColor"
                    :isWarned="child.isWarned"
                    :accessRoutesList="accessFrom"
                    @emitWarning="routeWarning"
                    :showCaption="false"
                    :showDate="true"
                    :onlyHeader="false"
                    :subRouteIndex="subRouteIndex"
                    :parentRouteId="parentRouteId"
                    :isOverdued="child.overdue_status"
                  />
                </v-card-subtitle>
                <v-card-subtitle class="mt-n6 indigo--text">
                  <!-- <v-tooltip top v-if="child.commentAccessConfig">
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-bind="attrs"
                        v-on="on"
                        :class="{
                          'grey--text text--darken-3': !subroute_comment_dialog,
                          'indigo--text': subroute_comment_dialog,
                        }"
                        @click="openRouteComments(child.id)"
                      >
                        <v-icon
                          small
                          :color="
                            !subroute_comment_dialog
                              ? 'grey darken-3'
                              : 'indigo'
                          "
                        >
                          mdi-message-text-outline
                        </v-icon>
                        Comments ({{ child.assigned_route_comments.length }})
                      </span>
                    </template>
                    <span>See comments</span>
                  </v-tooltip> -->
                </v-card-subtitle>
                <v-card-subtitle>
                  <v-container class="ml-n2">
                    <v-row class="mt-n4 mb-n10">
                      <v-col class="mb-n2" cols="6" v-if="child.uploadDocumentConfig">
                        <p
                          class="font-weight-regular body-2 grey--text text--darken-3"
                        >
                          Output Documents:
                        </p>
                      </v-col>
                      <v-col class="mb-n2" cols="6" v-if="child.uploadDocumentConfig">
                        <p
                          class="my-0 font-weight-regular body-2 grey--text text--darken-3"
                        >
                          Supporting Documents:
                        </p>
                      </v-col>
                      <v-col cols="6" class="mt-n4">
                        <div
                          class="records-list"
                          v-for="document in child.document_instances"
                          :key="document.id"
                          style="display: inline"
                        >
                          <v-menu
                            bottom
                            offset-x
                            origin="center center"
                            transition="scale-transition"
                            v-if="document.document_subroute[0].isMainDocument"
                          >
                            <template v-slot:activator="{ on }">
                              <v-tooltip top>
                                <template #activator="{ on: onTooltip }">
                                  <v-badge
                                    class="mt-n16"
                                    dot
                                    color="red"
                                    overlap
                                    v-if="
                                      document.document_subroute[0]
                                        .isMainDocument
                                    "
                                  >
                                    <v-icon
                                      v-on="getHandlers(on, onTooltip)"
                                      light
                                      dense
                                      large
                                      color="indigo"
                                    >
                                      mdi-file-document-outline
                                    </v-icon>
                                  </v-badge>
                                </template>
                                <span>
                                  <v-row style="width: 500px">
                                    <v-col cols="12">
                                      <v-simple-table dense>
                                        <template v-slot:default>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <span
                                                  class="
                                                indigo--text
                                                font-weight-bold
                                              "
                                                  >Sender:</span
                                                >
                                                {{ document.document.sender }}
                                              </td>
                                              <td>
                                                <span
                                                  class="
                                                indigo--text
                                                font-weight-bold
                                              "
                                                  >Type:</span
                                                >
                                                {{
                                                  document.document
                                                    .document_type
                                                    ? document.document
                                                        .document_type.name
                                                    : "none"
                                                }}
                                              </td>
                                            </tr>
                                            <!-- <tr>
                                              <td>
                                                <span
                                                  class="indigo--text font-weight-bold"
                                                  >Title:</span
                                                >
                                                {{ document.document.title }}
                                              </td>
                                              
                                            </tr>
                                            <tr>
                                              <td colspan="2">
                                                <span
                                                  class="indigo--text font-weight-bold"
                                                  >Address:</span
                                                >
                                                {{ document.document.address }}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <span
                                                  class="indigo--text font-weight-bold"
                                                  >For:</span
                                                >
                                                {{ document.document.for }}
                                              </td>
                                              <td>
                                                <span
                                                  class="indigo--text font-weight-bold"
                                                  >Source:</span
                                                >
                                                {{ document.document.source }}
                                              </td>
                                            </tr> -->
                                            <tr>
                                              <td>
                                                <span
                                                  class="
                                                indigo--text
                                                font-weight-bold
                                              "
                                                  >Subject:</span
                                                >
                                                {{ document.document.subject }}
                                              </td>
                                              <td>
                                                <span
                                                  class="
                                                indigo--text
                                                font-weight-bold
                                              "
                                                  >Date Uploaded:</span
                                                >
                                                {{
                                                  formatDocumentDate(
                                                    document.document
                                                      .date_uploaded
                                                  )
                                                }}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td colspan="2">
                                                <span
                                                  class="
                                                indigo--text
                                                font-weight-bold
                                              "
                                                  >File URL:</span
                                                >
                                                {{
                                                  document.document.filepath_url
                                                }}
                                              </td>
                                            </tr>
                                          </tbody>
                                        </template>
                                      </v-simple-table>
                                    </v-col>
                                  </v-row>
                                </span>
                              </v-tooltip>
                            </template>
                            <v-list>
                              <v-list-item
                                class="menu-item"
                                @click="openDocumentVersionDialog(document)"
                                v-if="menu_access || isInitiator"
                              >
                                <v-list-item-title
                                  >Upload New Version</v-list-item-title
                                >
                              </v-list-item>
                              <v-list-item
                                class="menu-item"
                                @click="
                                  viewDocument(
                                    `${fileSystemUrl}/view/${document.filepath_url}`
                                  )
                                "
                              >
                                <v-list-item-title
                                  >View Document</v-list-item-title
                                >
                              </v-list-item>
                              <v-list-item
                                class="menu-item"
                                @click="deleteOutputDocument(document.id)"
                                v-if="menu_access || isInitiator"
                              >
                                <v-list-item-title
                                  >Delete Document</v-list-item-title
                                >
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </div>
                        <v-menu bottom>
                          <template
                            v-slot:activator="{ on, attrs }"
                            v-if="child.uploadDocumentConfig"
                          >
                            <v-icon
                              style="cursor: pointer;"
                              class="mx-1 my-1 ml-4 mt-2"
                              light
                              dense
                              color="grey lighten-1"
                              v-on="on"
                              v-bind="attrs"
                              v-if="menu_access || isInitiator"
                            >
                              <!-- mdi-file-plus-outline -->
                              mdi-plus-circle
                            </v-icon>
                          </template>
                          <v-list>
                            <v-list-item
                              class="menu-item"
                              @click="addOutputDocument(child.id)"
                            >
                              <v-list-item-title
                                >Upload Output Document</v-list-item-title
                              >
                            </v-list-item>

                            <v-list-item
                              class="menu-item"
                              @click="useEmployeeOutputDocument(child.id)"
                            >
                              <v-list-item-title
                                >Use Employee's Output
                                Document</v-list-item-title
                              >
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-col>
                      <v-col cols="6" class="mt-n4">
                        <div
                          class="records-list"
                          v-for="document in child.document_instances"
                          :key="document.id"
                          style="display: inline"
                        >
                          <v-menu
                            bottom
                            offset-x
                            origin="center center"
                            transition="scale-transition"
                            v-if="!document.document_subroute[0].isMainDocument"
                          >
                            <template v-slot:activator="{ on }">
                              <v-tooltip top>
                                <template #activator="{ on: onTooltip }">
                                  <v-badge
                                    class="mt-n16"
                                    dot
                                    color="white"
                                    overlap
                                    v-if="
                                      !document.document_subroute[0]
                                        .isMainDocument
                                    "
                                  >
                                    <v-icon
                                      v-on="getHandlers(on, onTooltip)"
                                      class="mx-1"
                                      light
                                      dense
                                      large
                                      color="indigo"
                                    >
                                      mdi-file-document-outline
                                    </v-icon>
                                  </v-badge>
                                </template>
                                <span>
                                  <v-row style="width: 500px">
                                    <v-col cols="12">
                                      <v-simple-table dense>
                                        <template v-slot:default>
                                          <tbody>
                                            <tr>
                                              <td>
                                                <span
                                                  class="indigo--text font-weight-bold"
                                                  >Remarks:</span
                                                >
                                                {{
                                                  document.document_subroute[0]
                                                    .remarks != ""
                                                    ? document
                                                        .document_subroute[0]
                                                        .remarks
                                                    : "No remarks provided"
                                                }}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td colspan="2">
                                                <span
                                                  class="indigo--text font-weight-bold"
                                                  >File URL:</span
                                                >
                                                {{ document.filepath_url }}
                                              </td>
                                            </tr>
                                          </tbody>
                                        </template>
                                      </v-simple-table>
                                    </v-col>
                                  </v-row>
                                </span>
                              </v-tooltip>
                            </template>
                            <v-list>
                              <!-- <v-list-item class="menu-item" v-if="parentRouteId">
                            <v-list-item-title @click="attachRouteToParent(document)">Attach Document To Upper Route</v-list-item-title>
                          </v-list-item> -->
                              <v-list-item
                                class="menu-item"
                                @click="openDocumentVersionDialog(document)"
                              >
                                <v-list-item-title
                                  >Upload New Version</v-list-item-title
                                >
                              </v-list-item>
                              <v-list-item
                                class="menu-item"
                                @click="
                                  viewDocument(
                                    `${fileSystemUrl}/view/${document.filepath_url}`
                                  )
                                "
                              >
                                <v-list-item-title
                                  >View Document</v-list-item-title
                                >
                              </v-list-item>
                              <v-list-item
                                class="menu-item"
                                @click="deleteOutputDocument(document.id)"
                              >
                                <v-list-item-title
                                  >Delete Document</v-list-item-title
                                >
                              </v-list-item>
                            </v-list>
                          </v-menu>
                          <!-- <v-btn
                              v-else
                              fab
                              large
                              depressed
                              light
                              class="mr-4"
                              v-bind="attrs"
                              v-on="on"
                              @click="
                                viewDocument(
                                  `${fileSystemUrl}/view/${document.filepath_url}`
                                )
                              "
                            >
                              <v-icon
                                large
                                :color="
                                  document.document.type != 'output' ? 'green' : 'indigo'
                                "
                                >mdi-file-document-outline</v-icon
                              >
                            </v-btn> -->
                          <!-- </template> -->
                          <!-- <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                class="mx-1 my-1"
                                v-bind="attrs"
                                v-on="on"
                                large
                                :color="
                                  document.document.type != 'output' ? 'indigo' : 'indigo'
                                "
                                @click="viewDocument(`${fileSystemUrl}/view/${document.filepath_url}`)"
                                >mdi-file-document-outline</v-icon
                              >
                        </template> -->
                          <!-- </v-tooltip> -->
                        </div>

                        <div class="d-inline">
                          <div
                            class="records-list"
                            v-for="record in child.records"
                            :key="record.id"
                            style="display: inline"
                          >
                            <v-menu
                              bottom
                              offset-x
                              origin="center center"
                              transition="scale-transition"
                            >
                              <template v-slot:activator="{ on }">
                                <v-tooltip top>
                                  <template #activator="{ on: onTooltip }">
                                    <v-badge
                                      class="mt-n16"
                                      dot
                                      color="white"
                                      overlap
                                    >
                                      <v-icon
                                        v-on="getHandlers(on, onTooltip)"
                                        class="mx-1"
                                        large
                                        color="green"
                                      >
                                        mdi-file-document-outline
                                      </v-icon>
                                    </v-badge>
                                  </template>
                                  <span>
                                    <v-row style="width: 500px">
                                      <v-col cols="12">
                                        <v-simple-table dense>
                                          <template v-slot:default>
                                            <tbody>
                                              <tr>
                                                <td>
                                                  <span
                                                    class="indigo--text font-weight-bold"
                                                    >Name:</span
                                                  >
                                                  {{ record.name }}
                                                </td>
                                                <td>
                                                  <span
                                                    class="indigo--text font-weight-bold"
                                                    >Title:</span
                                                  >
                                                  {{ record.title }}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <span
                                                    class="indigo--text font-weight-bold"
                                                    >For:</span
                                                  >
                                                  {{ record.for }}
                                                </td>
                                                <td>
                                                  <span
                                                    class="indigo--text font-weight-bold"
                                                    >Source:</span
                                                  >
                                                  {{ record.source }}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <span
                                                    class="indigo--text font-weight-bold"
                                                    >Subject:</span
                                                  >
                                                  {{ record.subject }}
                                                </td>
                                                <td>
                                                  <span
                                                    class="indigo--text font-weight-bold"
                                                    >Sender:</span
                                                  >
                                                  {{ record.sender }}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <span
                                                    class="indigo--text font-weight-bold"
                                                    >Date Uploaded:</span
                                                  >
                                                  {{ record.date_uploaded }}
                                                </td>
                                                <td>
                                                  <span
                                                    class="indigo--text font-weight-bold"
                                                    >Record Date:</span
                                                  >
                                                  {{ record.record_date }}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <span
                                                    class="indigo--text font-weight-bold"
                                                    >Remarks:</span
                                                  >
                                                  {{
                                                    record.record_subroute[0]
                                                      .remarks != ""
                                                      ? record
                                                          .record_subroute[0]
                                                          .remarks
                                                      : "No remarks provided"
                                                  }}
                                                </td>
                                                <td colspan="2">
                                                  <span
                                                    class="indigo--text font-weight-bold"
                                                    >Address:</span
                                                  >
                                                  {{ record.address }}
                                                </td>
                                              </tr>
                                              <!-- <tr>
                                            <td colspan="2">
                                              <span class="indigo--text font-weight-bold"
                                                >File URL:</span
                                              >
                                              {{ document.filepath_url }}
                                            </td>
                                          </tr> -->
                                            </tbody>
                                          </template>
                                        </v-simple-table>
                                      </v-col>
                                    </v-row>
                                  </span>
                                </v-tooltip>
                              </template>

                              <v-list>
                                <!-- <v-list-item class="menu-item" v-if="parentRouteId">
                              <v-list-item-title @click="attachRouteToParent(document)">Attach Document To Upper Route</v-list-item-title>
                            </v-list-item> -->
                                <v-list-item
                                  class="menu-item"
                                  @click="
                                    viewDocument(
                                      `${fileSystemUrl}/view/${record.filepath_url}`
                                    )
                                  "
                                >
                                  <v-list-item-title
                                    >View Record</v-list-item-title
                                  >
                                </v-list-item>
                                <v-list-item
                                  class="menu-item"
                                  @click="deleteRecord(record.id)"
                                  v-if="loggedInPosition == 'Records Officer'"
                                >
                                  <v-list-item-title
                                    >Delete Record</v-list-item-title
                                  >
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </div>
                        </div>
                        <div class="d-inline">
                          <div
                            class="records-list"
                            v-for="record in child.route_record_requests"
                            :key="record.id"
                            style="display: inline"
                          >
                            <v-menu
                              bottom
                              offset-x
                              origin="center center"
                              transition="scale-transition"
                            >
                              <template v-slot:activator="{ on }">
                                <v-tooltip top>
                                  <template #activator="{ on: onTooltip }">
                                    <v-badge
                                      class="mt-n16"
                                      :color="requestRecordColor(record.status)"
                                      :icon="requestRecordIcon(record.status)"
                                      overlap
                                    >
                                      <v-icon
                                        v-on="getHandlers(on, onTooltip)"
                                        class="mx-1"
                                        large
                                        color="grey"
                                      >
                                        mdi-file-document-outline
                                      </v-icon>
                                    </v-badge>
                                  </template>
                                  <span>
                                    <v-row style="width: 500px">
                                      <v-col cols="12">
                                        <v-simple-table dense>
                                          <template v-slot:default>
                                            <tbody>
                                              <tr>
                                                <td>
                                                  <span
                                                    class="indigo--text font-weight-bold"
                                                    >Date Requested:</span
                                                  >
                                                  {{
                                                    formatDocumentDate(
                                                      record.createdAt
                                                    )
                                                  }}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <span
                                                    class="indigo--text font-weight-bold"
                                                    >Message Request:</span
                                                  >
                                                  {{ record.message }}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <span
                                                    class="indigo--text font-weight-bold"
                                                    >Date Uploaded:</span
                                                  >
                                                  {{
                                                    formatDocumentDate(
                                                      record.date_uploaded
                                                    )
                                                  }}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td>
                                                  <span
                                                    class="indigo--text font-weight-bold"
                                                    >Status:</span
                                                  >
                                                  {{ record.status }}
                                                </td>
                                              </tr>
                                              <tr>
                                                <td colspan="2">
                                                  <span
                                                    class="indigo--text font-weight-bold"
                                                    >Remarks:</span
                                                  >
                                                  {{
                                                    record.remarks != ""
                                                      ? record.remarks
                                                      : "No remarks provided"
                                                  }}
                                                </td>
                                              </tr>
                                            </tbody>
                                          </template>
                                        </v-simple-table>
                                      </v-col>
                                    </v-row>
                                  </span>
                                </v-tooltip>
                              </template>

                              <v-list>
                                <!-- <v-list-item class="menu-item" v-if="parentRouteId">
                              <v-list-item-title @click="attachRouteToParent(document)">Attach Document To Upper Route</v-list-item-title>
                            </v-list-item> -->
                                <v-list-item
                                  class="menu-item"
                                  @click="
                                    viewDocument(
                                      `${fileSystemUrl}/view/${record.filepath_url}`
                                    )
                                  "
                                >
                                  <v-list-item-title
                                    >View Record</v-list-item-title
                                  >
                                </v-list-item>
                                <v-list-item
                                  v-if="loggedInPosition == 'Records Officer'"
                                  class="menu-item"
                                  @click="deleteRecord(record.id)"
                                >
                                  <v-list-item-title
                                    >Delete Record</v-list-item-title
                                  >
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </div>
                        </div>
                        <v-menu bottom v-if="child.uploadDocumentConfig">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              style="cursor: pointer;"
                              class="mx-1 my-1 ml-4 mt-2"
                              light
                              dense
                              color="grey lighten-1"
                              v-on="on"
                              v-bind="attrs"
                              v-if="menu_access || isInitiator"
                            >
                              <!-- mdi-file-plus-outline -->
                              mdi-plus-circle
                            </v-icon>
                          </template>
                          <v-list>
                            <v-list-item
                              class="menu-item"
                              @click="addSupportingDocument()"
                            >
                              <v-list-item-title
                                >Upload Supporting Document</v-list-item-title
                              >
                            </v-list-item>

                            <v-list-item
                              class="menu-item"
                              v-if="loggedInPosition == 'Records Officer'"
                              @click="addRouteRecord(child.id)"
                            >
                              <v-list-item-title
                                >Attach Records</v-list-item-title
                              >
                            </v-list-item>

                            <v-list-item
                              class="menu-item"
                              @click="addRouteRequest()"
                            >
                              <v-list-item-title
                                >Request Record Attachment</v-list-item-title
                              >
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-subtitle>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6">
            <v-row class="mt-n4">
              <v-col class="mt-3">
                <strong class="indigo--text">Activity Logs</strong>
              </v-col>
              <v-col
                cols="6"
                class="d-inline-flex justify-end"
                style="width: 100%;"
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      v-bind="attrs"
                      v-on="on"
                      class="my-0 font-weight-regular body-2 indigo--text pt-2"
                    >
                      <p
                        class="my-0 font-weight-regular body-2"
                        :class="
                          computedDisableStatus ? 'indigo--text' : 'grey--text'
                        "
                      >
                        {{
                          computedStatuses.length > 0
                            ? computedStatuses[computedStatuses.length - 1]
                                .status.name
                            : ""
                        }}
                      </p>
                    </div>
                  </template>
                  <span>Current Route Status</span>
                </v-tooltip>

                <!-- // ? button for initiator -->
                <v-btn
                  v-if="computedDisableStatus && isInitiator"
                  depressed
                  :elevation="0"
                  text
                  icon
                  color="orange"
                  class="ml-2"
                  small
                  @click="confirmSubrouteStatus()"
                >
                  <v-icon>mdi-clipboard-alert-outline</v-icon>
                </v-btn>
                <!-- // ? button for initiator -->

                <!-- // ! button for user -->
                <v-btn
                  v-if="menu_access"
                  depressed
                  :elevation="0"
                  text
                  icon
                  color="indigo"
                  class="ml-2"
                  small
                  @click="updateStatus(child)"
                >
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
                <!-- // ! button for user -->
                <v-badge
                  :content="logCount"
                  :value="child.user_id === userAccess ? logCount : 0"
                  color="red lighten-1"
                  overlap
                  class="pr-8 mr-n10"
                >
                  <v-menu
                    bottom
                    left
                    v-if="
                      comment_access != false ||
                        menu_access != false ||
                        subroute_access != false
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn light icon v-bind="attrs" v-on="on" class="mr-n16">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>

                    <v-list>
                      <v-list-item
                        v-if="menu_access != false || subroute_access != false"
                      >
                        <v-list-item-content>
                          <v-list-item-title
                            class="list-item"
                            @click="openSubRoutesList(child.id)"
                          >
                            <v-icon class="mr-3" small>mdi-routes</v-icon>
                            {{ isSelected ? "Close " : "Open " }} Sub Routes
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item
                      >
                        <v-list-item-content>
                          <v-list-item-title
                            class="list-item"
                            @click="seeTransactionLog(child.id)"
                          >
                            <v-icon class="mr-3" small>mdi-clipboard-text</v-icon>
                            Sub-Route Tracking Details
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item
                        v-if="menu_access != false || subroute_access != false"
                      >
                        <v-list-item-content>
                          <v-list-item-title
                            class="list-item"
                            @click="addSubRoute(child.id)"
                          >
                            <v-icon class="mr-3" small>mdi-account-plus</v-icon>
                            Add Sub-Routes
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>

                      <v-list-item v-if="child.commentAccessConfig">
                        <v-list-item-content
                          v-if="comment_access != false || isChild != false"
                        >
                          <v-list-item-title
                            class="list-item"
                            @click="openRouteComments(child.id)"
                          >
                            <v-icon class="mr-3" small>mdi-message-text</v-icon>
                            {{
                              subroute_comment_dialog != false
                                ? "Close "
                                : "Open "
                            }}
                            Route Comments
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>

                      <v-list-item v-if="menu_access">
                        <v-list-item-content>
                          <v-list-item-title
                            class="list-item"
                            @click="delegateSubroute(child)"
                          >
                            <v-icon class="mr-3" small
                              >mdi-account-switch-outline</v-icon
                            >
                            Delegate Sub-route asset
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>

                      <v-list-item v-if="delete_access">
                        <v-list-item-content>
                          <v-list-item-title
                            class="list-item"
                            @click="deleteSubRoute(child.id)"
                          >
                            <v-icon class="mr-3" small>mdi-trash-can</v-icon>
                            Delete Sub-route
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>

                      <v-list-item v-if="menu_access">
                        <v-list-item-content>
                          <v-list-item-title
                            class="list-item"
                            @click="updateRouteCompeleted(child.id)"
                          >
                            <v-icon class="mr-3" small>mdi-check</v-icon>
                            Route Completed
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-badge>
              </v-col>
              <v-col
                cols="12"
                class="overflow-y-auto p-0 m-0"
                style="max-height: 250px; width: 100%"
              >
                <SubRouteTrackingLog
                  v-if="fetch_log_status"
                  :dialog="true"
                  :routeId="child.id"
                  :logs="child.logs"
                  :notifLogCount="child.notifLogCount"
                  :userAccessing="userAccess"
                  :routeUserAssigned="child.user_id"
                  :routeType="'subroute'"
                  @closeDialog="closeLog"
                  @setNewLogCount="setLogCount"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" v-show="subroute_comment_dialog">
            <SubRouteComments
              :routeCommentName="`dialog_route_${child.id}`"
              :comment_dialog="`dialog_${selected_subroute_comments}`"
              :routeId="child.id"
              :routeType="routeType"
              :inSubRoutes="inSubRoutes"
              :subRouteIndex="subRouteIndex"
              :accessFrom="accessFrom"
              :parentRouteId="parentRouteId"
              @closeComments="openRouteComments"
              :accessRoute="accessRoute"
            />
          </v-col>
        </v-row>
        <SubRouteFooter
          :routeId="child.id"
          :parentRouteId="parseInt(parentRouteId)"
          :isChild="isChild"
          :currentStatus="child.autoCompleteTrigger"
        />
      </v-container>
      <v-progress-linear
        v-show="computedProgress > 0"
        dark
        :value="computedProgress"
        height="20"
        :color="computedProgress > 99 ? 'success' : 'primary'"
      >
        <strong>{{ Math.ceil(computedProgress) }}%</strong>
      </v-progress-linear>
    </v-card>

    <v-dialog v-model="confirm_dialog" max-width="500px" persistent>
      <v-card>
        <v-card-title>
          <span class="text-h5">Sub-route Status Confirmation</span>
        </v-card-title>
        <v-card-text>
          <p class="h1">
            Pending Status:
            <span class="indigo--text">{{ pending_status_name }}</span>
          </p>
          <v-container>
            <v-row>
              <v-col cols="12" class="my-n6">
                <v-radio-group v-model="confirm_action" row mandatory>
                  <v-radio label="Approve" value="confirm"></v-radio>
                  <v-radio label="Reject" value="reject"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-textarea
                  outlined
                  name="input-7-4"
                  label="Remarks"
                  value=""
                  v-model="confirm_status_remarks"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="confirm_dialog = false">
            Close
          </v-btn>
          <v-btn color="indigo" text @click="confirmPendingStatus()">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <AddReceiverModal
      :dialog="subroute_dialog"
      :parentRoute="parent_route"
      :parentRouteType="parent_route_type"
      @closeDialog="closeReceiverModal"
      :mainRoute="routeId"
      accessFrom="subroute"
      :userAssigned="child.user.id"
      :initiatorDueDate="datetime_due"
    />

    <AddDocument
      :dialog="document_dialog"
      :routeId="route_document_select"
      :initiatorId="parseInt(routeId)"
      :isMainRoute="is_main_route_document"
      :subRouteIndex="subRouteIndex"
      :inSubRoutes="inSubRoutes"
      :accessFrom="accessFrom"
      :isStandalone="false"
      @closeDialog="closeDocumentModal"
    />

    <UpdateRouteStatusDialog
      :dialog="route_status_dialog"
      :routeId="selected_subroute"
      :routeCurrentStatus="selected_subroute_status"
      :routeType="routeType"
      :subRouteIndex="subRouteIndex"
      :parentRouteId="parentRouteId"
      :saveType="route_status_save_type"
      :currentRouteStatus="current_route_status"
      :statusTemplate="selected_subroute_status_template"
      @closeDialog="closeSubRouteStatus"
      @addedStatus="pushStatus"
    />

    <SubRouteDetailsModal
      :dialog="subroute_details_dialog"
      :routeId="select_parent_route"
      :modalName="`subroute-details${select_parent_route}`"
      @closeDialog="subRouteCloseModal"
      :isInitiator="isInitiator"
      :userAccess="userAccess"
      :mainDocument="mainDocument"
      :accessFrom="accessFrom == 'mainroute' ? 'secondaryroute' : 'subroute'"
      :parentRouteDue="parentRouteDue"
    />

    <AttachRecordModal
      :dialog="route_record_dialog"
      :routeId="route_record_select"
      :routeType="routeType"
      :subRouteIndex="subRouteIndex"
      :parentRouteId="parentRouteId"
      @closeDialog="closeRouteRecordsModal"
    />

    <UploadDocumentVersionDialog
      :dialog="document_version_dialog"
      :documentId="select_version_id"
      :transactionId="select_version_transaction_id"
      :document="document_versioning"
      :routeId="child.id"
      :routeType="routeType"
      :subRouteIndex="subRouteIndex"
      :parentRouteId="parentRouteId"
      @closeDialog="closeDocumentVersionDialog"
    />

    <UploadOutputDocumentModal
      :dialog="output_document_dialog"
      :routeId="child.id"
      :document="mainDocument"
      :type="upload_document_type"
      :routeType="routeType"
      :subRouteIndex="subRouteIndex"
      :parentRouteId="parentRouteId"
      @closeDialog="closeOutputModal"
    />

    <OutputDocumentDialog
      :dialog="reference_output_dialog"
      :initiatorId="parseInt(initiator_id)"
      :routeId="reference_route_output_dialog"
      :routeType="'subroute'"
      @closeDialog="closeReferenceDocumentDialog"
      @referenceDocument="referenceOutputDocument"
    />

    <RouteRequestDialog
      :dialog="record_request_dialog"
      :routeId="child.id"
      :routeType="routeType"
      @closeDialog="closeRouteRequestDialog"
    />

    <DelegateRouteDialog
      :dialog="delegate_dialog"
      :routeId="delegate_route_id"
      :userAssigned="delegated_assigned_user"
      :initiatorDueDate="datetime_due"
      @closeDialog="closeDelegateDialog"
    />
    <SubRouteLogTrackModal
      :dialog="route_log_dialog"
      :routeId="selected_log_id"
      :routeType="'mainroute'"
      @closeDialog="closeLog"
    />
  </div>
</template>

<script>
  import Swal from "sweetalert2";
  import { mapActions, mapGetters } from "vuex";
  import moment from "moment";
  import { fileSystemUrl as fsUrl } from "../../config/config.json";
  import SubRouteLogTrackModal from "./SubRouteLogTrackModal.vue"
  import AddReceiverModal from "../AddReceiverModal";
  import AddDocument from "../AddDocuments";
  import UpdateRouteStatusDialog from "../../components/sub_routes/UpdateRouteStatusDialog";
  import SubRouteDetailsModal from "../../components/sub_routes/SubRouteDetailsModal";
  import SubRouteComments from "../../components/sub_routes/SubRouteComments";
  import DateCountdown from "../../components/DateCountdown";
  import AttachRecordModal from "../records/AttachRecordModal";
  import UploadDocumentVersionDialog from "../documents/UploadDocumentVersionDialog";
  import UploadOutputDocumentModal from "../documents/UploadOutputDocumentModal";
  import OutputDocumentDialog from "../documents/OutputDocumentDialog";
  import RouteRequestDialog from "../records/RouteRequestDialog";
  import DelegateRouteDialog from "../sub_routes/DelegateRouteDialog";
  import SubRouteFooter from "./SubRouteFooter";
  import SubRouteTrackingLog from "./SubRouteTrackingLog.vue";

  export default {
    name: "SecondaryRoutes",
    props: {
      child: Object,
      routeId: String,
      inSubRoutes: Boolean,
      subRouteIndex: Number,
      routeType: String,
      isSibling: Boolean,
      isParent: Boolean,
      userAccess: Number,
      isChild: Boolean,
      accessRoute: Number,
      isInitiator: Boolean,
      accessFrom: String,
      mainDocument: Object,
      parentRouteId: String,
      parentRouteDue: String,
    },
    components: {
      AddReceiverModal,
      SubRouteLogTrackModal,
      AddDocument,
      UpdateRouteStatusDialog,
      SubRouteDetailsModal,
      SubRouteComments,
      DateCountdown,
      AttachRecordModal,
      UploadDocumentVersionDialog,
      UploadOutputDocumentModal,
      OutputDocumentDialog,
      RouteRequestDialog,
      DelegateRouteDialog,
      SubRouteFooter,
      SubRouteTrackingLog,
    },
    data() {
      return {
        fileSystemUrl: fsUrl,
        initiator_id: this.$route.params.id,
        subroute_details_dialog: false,
        document_version_dialog: false,
        subroute_dialog: false,
        parent_route: null,
        parent_route_type: "subroute",
        document_dialog: false,
        route_document_select: null,
        is_main_route_document: true,
        route_status_dialog: false,
        selected_subroute: null,
        selected_subroute_status: null,
        select_parent_route: null,
        selected_subroute_comments: null,
        subroute_comment_dialog: false,
        isSelected: false,
        statuses: [],
        show: false,
        subrouteSelected: false,
        comment_access:
          this.isSibling === true ||
          this.isParent === true ||
          this.userAccess === this.child.user_id ||
          this.isInitiator === true
            ? true
            : false,
        menu_access: this.child.user_id === this.userAccess ? true : false,
        subroute_access:
          this.isChild === true && this.isInitiator !== true ? true : false,
        delete_access:
          this.isChild === true || this.isInitiator === true ? true : false,
        route_status: null,
        route_record_dialog: false,
        route_record_select: null,
        route_log_dialog: false,
        selected_log_id: null,
        view_more_status: false,
        output_document_dialog: false,
        upload_document_type: "output",
        datetime_due: null,
        reference_output_dialog: false,
        reference_route_output_dialog: null,
        select_version_id: null,
        select_version_transaction_id: null,
        document_versioning: {},
        record_request_dialog: false,
        delegate_route_id: null,
        delegate_dialog: false,
        delegated_assigned_user: null,
        fetch_log_status: false,
        logCount: 0,
        route_status_save_type: "create",
        current_route_status: null,
        confirm_dialog: false,
        pending_status_name: "",
        confirm_status_remarks: "",
        confirm_action: "cofirm",
        selected_subroute_status_template: [],
      };
    },
    computed: {
      ...mapGetters([
        "getSubRoutes",
        "openedSubRouteContainers",
        "loggedInPosition",
      ]),
      computedStatuses: function() {
        return this.statuses;
      },
      computedDisableStatus: function() {
        if (this.statuses.length > 0) {
          if (
            this.statuses[this.statuses.length - 1].confirm_status == "pending"
          ) {
            return true;
          } else {
            return false;
          }
        }
        return false;
      },
      computedClasses: function() {
        var returnClass = "";
        if (this.openedSubRouteContainers[this.subRouteIndex + 1] != null) {
          if (
            this.openedSubRouteContainers[this.subRouteIndex + 1] ==
            this.child.id
          ) {
            returnClass = "selected-route";
          } else {
            returnClass = "unselected-route";
          }
        }

        return returnClass;
      },
      computedStatusColor: function() {
        var color = "";

        if (this.route_status == "Pending") {
          color = "";
        } else if (this.route_status == "Done") {
          color = "green lighten-4";
        } else if (this.route_status == "Overdue") {
          color = "red lighten-4";
        } else if (this.route_status == "Warning") {
          color = "yellow lighten-4";
        } else {
          color = "";
        }

        return color;
      },
      computedInstructions: function() {
        return this.child.instructions.length < 150
          ? this.child.instructions
          : this.child.instructions.substring(0, 150) + `...`;
      },
      computedChip: function() {
        let chipType = 1;

        if (
          this.childWarningStatus == true &&
          this.child.status != "Done" &&
          this.child.overdue_status != true
        )
          chipType = 1;
        else if (this.child.status == "Done") chipType = 2;
        else if (this.child.overdue_status && this.child.status != "Done")
          chipType = 3;
        else chipType = 4;

        return chipType;
      },
      computedProgress: function() {
        if (this.statuses.length < 1) return 0;

        const totalStatuses = this.child.subroute_order_statuses.length;

        let lastIndex = this.statuses.length - 1;
        let continueSearch = true;

        while (continueSearch) {
          if (this.statuses[lastIndex].confirm_status == "confirmed") {
            continueSearch = false;
          } else {
            --lastIndex;
            if (lastIndex < 0) continueSearch = false;
          }
        }

        if (lastIndex !== -1) {
          const lastStatus = this.statuses[lastIndex].status.id;
          let progressCount = 1;
          let findStatus = true;

          for (let i = 0; i < this.child.subroute_order_statuses.length; i++) {
            if (
              this.child.subroute_order_statuses[progressCount - 1].status_id ==
              lastStatus
            ) {
              findStatus = false;
              break;
            } else {
              if (findStatus) progressCount++;
            }
          }

          const percentage = Math.floor((progressCount / totalStatuses) * 100);

          if (
            percentage > 99 &&
            this.child.status !== "Done" &&
            this.child.autoCompleteTrigger === true
          ) {
            this.updateRouteCompeleted(this.child.id);
          }

          return percentage;
        } else {
          return 0;
        }
      },
    },
    methods: {
      ...mapActions([
        "fetchParentSubRoutes",
        "addSubRouteContainer",
        "removeSubRouteSelection",
        "setSubRouteCompeleted",
        "attachToParentOutputDocument",
        "attachToSubRouteParentOutputDocument",
        "addChildSubrouteOutputDocument",
        "addSubrouteOutputDocument",
        "removeRouteDocument",
        "removeSubRouteDocument",
        "removeRouteRecord",
        "removeSubRouteRecord",
        "deleteSecondaryRoute",
        "addRequestToRoute",
        "addRequestToSubRoute",
        "setSecondaryRouteCompleted",
        "confirmRouteStatus",
        "fetchRouteLog",
        "fetchSubRouteLog",
      ]),
      viewDocument(link) {
        open(link);
      },
      getHandlers() {
        return [...arguments].reduce((seed, item) => {
          const mergedHandlers = { ...item, ...seed };

          return mergedHandlers;
        }, {});
      },
      addSubRoute(route_id) {
        this.subroute_dialog = true;
        this.parent_route = route_id;
        this.parent_route_type = "subroute";
      },
      closeReceiverModal() {
        this.subroute_dialog = false;
        this.parent_route = null;
        this.parent_route_type = "mainroute";
      },
      addOutputDocument(route_id) {
        this.output_document_dialog = true;
        this.route_document_select = route_id;
        this.is_main_route_document = false;
        this.upload_document_type = "output";
      },
      closeDocumentModal(val) {
        console.log(val);
        this.document_dialog = false;
      },
      updateStatus(route) {
        let statuses = this.statuses;
        const len = statuses.length - 1;

        if (statuses.length > 0) {
          if (statuses[len].confirm_status != "pending") {
            this.route_status_save_type = "create";
            this.current_route_status = null;
          } else {
            this.route_status_save_type = "update";
            this.current_route_status = statuses[len];
          }
        } else {
          this.route_status_save_type = "create";
          this.current_route_status = null;
        }

        this.route_status_dialog = true;
        this.selected_subroute = route.id;
        this.selected_subroute_status = route.status;
        this.selected_subroute_status_template = route.subroute_order_statuses;
      },
      closeSubRouteStatus() {
        this.route_status_dialog = false;
        this.selected_subroute_status_template = [];
      },
      openSubRoutesList(child_id) {
        if (!this.isSelected) {
          this.isSelected = true;
          this.select_parent_route = child_id.toString();

          if (this.getSubRoutes.length <= 0) {
            this.subroute_details_dialog = true;
          } else {
            this.addSubRouteContainer({
              id: child_id,
              index: this.subRouteIndex,
            });
          }
        } else {
          this.isSelected = false;
          this.removeSubRouteSelection({
            id: child_id,
            index: this.subRouteIndex,
          });
        }
      },
      subRouteCloseModal() {
        this.subroute_details_dialog = false;
        this.isSelected = false;
      },
      openRouteComments(child_id) {
        if (!this.subroute_comment_dialog) {
          this.show = true;
          this.subroute_comment_dialog = `route_${child_id}`;
          this.selected_subroute_comments = `route_${child_id}`;
        } else {
          this.subroute_comment_dialog = false;
          this.selected_subroute_comments = null;
        }
      },
      pushStatus(val) {
        this.statuses.push(val);
        // let status = Object.assign(val, {
        //   id: val.status_id,
        //   status: {
        //     id: val.status_id,
        //     name: val.name,
        //   },
        // });
        // this.statuses.push(status);
      },
      async updateRouteCompeleted(child_id) {
        let result;

        let body = {
          route_id: child_id,
          type: this.routeType,
          route_index: this.subRouteIndex,
          container: this.parentRouteId,
          access_from: this.accessFrom,
        };

        if (this.routeType == "subroute") {
          body = Object.assign(body, {
            route_index: this.subRouteIndex,
            container: this.parentRouteId,
          });
          result = await this.setSubRouteCompeleted(body);
        } else {
          result = await this.setSecondaryRouteCompleted({
            route_id: child_id,
            access_from: this.accessFrom,
          });
        }

        if (result.error) {
          if (result.status == 400) {
            Swal.fire({
              icon: "error",
              title: result.message.details,
              text: result.message.subtitle,
            });
          } else if (result.status == 403) {
            Swal.fire({
              icon: "error",
              title: "Unauthorized",
              text: result.message.details,
            });
          }
        } else {
          Swal.fire({
            icon: "success",
            title: "Route completed!",
            showConfirmButton: false,
            timer: 1500,
          });

          this.route_status = "Done";
        }
      },
      routeWarning(val) {
        if (val) {
          this.route_status = "Warning";
        }
      },
      addRouteRecord(id) {
        this.route_record_dialog = true;
        this.route_record_select = id;
      },
      closeRouteRecordsModal() {
        this.route_record_dialog = false;
      },
      seeTransactionLog(route_id) {
        this.selected_log_id = route_id;
        this.route_log_dialog = true;
      },
      closeLog() {
        this.route_log_dialog = false;
      },
      openDocumentVersionDialog(document) {
        this.document_version_dialog = true;
        this.select_version_id = document.document.id;
        this.select_version_transaction_id = document.document.transaction_id;

        this.document_versioning = {
          document_id: document.document_id,
          transaction_id: document.document.transaction_id,
          document_instance_id: document.id,
        };
      },
      closeDocumentVersionDialog(val) {
        this.document_version_dialog = false;

        if (val) {
          alert("document version uploaded");
        }
      },
      closeOutputModal() {
        this.output_document_dialog = false;
      },
      addSupportingDocument() {
        this.output_document_dialog = true;
        this.upload_document_type = "supporting";
      },
      async attachRouteToParent(document) {
        let body = {
          document_id: document.id,
          parent_id: this.parentRouteId,
          document: document,
          transaction_id: document.document.transaction_id,
        };

        let result;

        if (this.accessFrom == "secondaryroute") {
          result = await this.attachToParentOutputDocument(body);
        } else {
          result = await this.attachToSubRouteParentOutputDocument(body);
        }

        if (result.error) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Internal Server Error",
          });
        } else {
          Swal.fire("Saved!", "Output document attached", "success");
        }
      },
      useEmployeeOutputDocument(route_id) {
        this.reference_route_output_dialog = route_id;
        this.reference_output_dialog = true;
      },
      closeReferenceDocumentDialog() {
        this.reference_output_dialog = false;
        this.reference_route_output_dialog = null;
      },
      async referenceOutputDocument(val) {
        console.log(val);
        let result;

        let body = {
          route_id: this.child.id,
          transaction_id: val.documentDetails.transaction_id,
          document_id: val.documentDetails.id,
          filepath_url: val.document_route.filepath_url,
          date_uploaded: val.documentDetails.date_uploaded,
          route_type: this.routeType,
          referenced_route_id: val.instance_id,
        };

        if (
          this.routeType == "mainroute" ||
          this.routeType == "secondaryroute"
        ) {
          result = await this.addSubrouteOutputDocument(body);
        } else {
          body = Object.assign(body, {
            route_type: this.routeType,
            route_index: this.subRouteIndex,
            container: this.parentRouteId,
          });

          result = await this.addChildSubrouteOutputDocument(body);
        }

        if (result.error) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Internal Server Error",
          });
        } else {
          Swal.fire("Saved!", "Output document attached", "success");
          this.reference_route_output_dialog = null;
          this.reference_output_dialog = false;
        }
      },
      deleteOutputDocument(document_id) {
        let res;

        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        }).then(async result => {
          if (result.isConfirmed) {
            let body = {
              document_id,
              route_id: this.child.id,
              route_type: this.routeType,
              document_type: "supporting",
              initiator_id: this.initiator_id,
            };

            if (this.routeType != "subroute") {
              res = await this.removeRouteDocument(body);
            } else {
              body = Object.assign(body, {
                route_index: this.subRouteIndex,
                container: this.parentRouteId,
              });
              res = await this.removeSubRouteDocument(body);
            }

            if (res) {
              Swal.fire("Deleted!", "Your file has been deleted.", "success");
            }
          }
        });
      },
      deleteRecord(record_id) {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        }).then(async result => {
          if (result.isConfirmed) {
            let body = {
              record_id,
              route_id: this.child.id,
              route_type: this.routeType,
              document_type: "supporting",
              initiator_id: this.$route.params.id,
            };

            let result;

            if (this.routeType != "subroute") {
              result = await this.removeRouteRecord(body);
            } else {
              body = Object.assign(body, {
                route_index: this.subRouteIndex,
                container: this.parentRouteId,
              });

              result = await this.removeSubRouteRecord(body);
            }

            if (result) {
              Swal.fire("Deleted!", "Record has been deleted.", "success");
            }
          }
        });
      },
      deleteSubRoute(id) {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        }).then(result => {
          if (result) {
            this.deleteSecondaryRoute({
              route_id: id,
            });

            Swal.fire(
              "Deleted!",
              "Sub-route has been deleted." + id,
              "success"
            );
          }
        });
      },
      addRouteRequest() {
        this.record_request_dialog = true;
      },
      closeRouteRequestDialog(val) {
        this.record_request_dialog = false;
        if (val) {
          if (val.type == "secondaryroute") this.addRequestToRoute(val);
          else {
            val = Object.assign(val, {
              route_index: this.subRouteIndex,
              container: this.parentRouteId,
            });
            this.addRequestToSubRoute(val);
          }
        }
      },
      formatDocumentDate(date) {
        return moment(date).format("LLL");
      },
      requestRecordColor(status) {
        if (status == "Pending") {
          return "grey";
        } else if (status == "Approved") {
          return "green";
        } else {
          return "error";
        }
      },
      requestRecordIcon(status) {
        if (status == "Pending") {
          return "";
        } else if (status == "Approved") {
          return "mdi-check";
        } else {
          return "mdi-close";
        }
      },
      delegateSubroute(route) {
        this.delegate_route_id = route.id;
        this.delegate_dialog = true;
        this.delegated_assigned_user = route.user_id;
      },
      closeDelegateDialog() {
        this.delegate_dialog = false;
        // this.delegated_assigned_user = null;
        this.delegate_route_id = null;
      },
      confirmPendingStatus() {
        const status = this.statuses[this.statuses.length - 1];
        const body = {
          remarks: this.confirm_status_remarks,
          action: this.confirm_action,
          id: status.id,
          route_id: this.child.id,
          status_id: status.status.id,
        };

        this.confirmRouteStatus(body).then(() => {
          if (this.confirm_action == "reject") {
            Swal.fire("Status rejected!", "", "info");
          } else {
            Swal.fire("Status confirmed!", "", "success");

            // if(status.id ===)
          }

          this.confirm_dialog = false;
          this.pending_status_name = "";
        });

        console.log(body);
      },
      confirmSubrouteStatus() {
        this.confirm_dialog = true;
        const status = this.statuses[this.statuses.length - 1];
        // let remarks = "";
        this.pending_status_name = status.status.name;

        // console.log("the selected status", status);

        // Swal.fire({
        //   text: "Sub-route Status Confirmation",
        //   html: `Pending status: <span style="color: #7986CB;">${status.status.name}</span>`,
        //   showDenyButton: true,
        //   showCloseButton: true,
        //   confirmButtonText: `Approve`,
        //   denyButtonText: `Reject`,
        // }).then((result) => {
        //   if (result.isConfirmed) {
        //     const body = {
        //       remarks,
        //       action: "confirm",
        //       id: status.id,
        //       route_id: this.child.id,
        //       status_id: status.status.id,
        //     };

        //     this.confirmRouteStatus(body)
        //       .then(() => {
        //         Swal.fire("Status confirmed!", "", "success");
        //       })
        //       .catch((err) => {
        //         console.log(err);
        //       });
        //   } else if (result.isDenied) {
        //     Swal.fire({
        //       title: "Add your remarks",
        //       input: "text",
        //       inputAttributes: {
        //         autocapitalize: "off",
        //       },
        //       showCancelButton: true,
        //       confirmButtonText: "Submit",
        //       showLoaderOnConfirm: true,
        //       preConfirm: (resRemarks) => {
        //         remarks = resRemarks;
        //       },
        //       allowOutsideClick: () => !Swal.isLoading(),
        //     }).then((result) => {
        //       if (result.isConfirmed) {
        //         const body = {
        //           remarks,
        //           action: "reject",
        //           id: status.id,
        //           route_id: this.child.id,
        //           status_id: status.status.id,
        //         };

        //         this.confirmRouteStatus(body)
        //           .then(() => {
        //             Swal.fire("Status rejected!", "", "info");
        //           })
        //           .catch((err) => {
        //             console.log(err);
        //           });
        //       }
        //     });
        //     // Swal.fire('Changes are not saved', '', 'info')
        //   }
        // });
      },
      setLogCount() {
        this.logCount = this.child.notifLogCount;
      },
    },
    created() {
      this.statuses = this.child.subroute_status;
      // console.log('statuses', this.statuses);
      this.route_status = this.child.status;
      this.datetime_due = moment(this.child.datetime_due)
        .toISOString()
        .substr(0, 10);

      let body = {
        route_id: this.child.id,
        type: this.routeType,
        accessFrom: this.accessFrom,
      };

      if (this.routeType != "subroute") {
        this.fetchRouteLog(body).then(result => {
          this.logs = result;
          this.logCount = this.child.notifLogCount;
          this.fetch_log_status = true;
        });
      } else {
        body = Object.assign(body, {
          parent_id: this.parentRouteId,
        });

        this.fetchSubRouteLog(body).then(result => {
          this.logs = result;
          this.logCount = this.child.notifLogCount;
          this.fetch_log_status = true;
        });
      }
    },
  };
</script>

<style scoped>
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  .selected-route {
    /* border: 12px solid pink; */
    filter: drop-shadow(0 0 0.3rem #6a1da8);
  }

  .unselected-route {
    filter: blur(3px);
  }

  .list-item {
    cursor: pointer;
    font-size: 14px;
  }

  .menu-item {
    cursor: pointer;
  }

  /* width */
  ::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #b5b5b5;
    border-radius: 10px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #7b7b7b;
  }
</style>
